const ProyectName = 'MallAventura - ';


export const SessionData = ProyectName + 'sessionData';
export const SessionRespuesta = ProyectName + 'SessionRespuesta';
export const UsersList = ProyectName + 'UsersList';
export const SessionReset = ProyectName + 'SessionReset';
export const AppTitle = 'Mall Aventura';
export const PathName = 'Pathname';